import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {
  ActionResult,
  ActionResultList, CategoryItem, CompetitorFilter, CompetitorResults, PagedFilter,
} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class CompetitorResultsService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  getCompetitorResults(filter: PagedFilter<CompetitorFilter>): Observable<CompetitorResults[]> {
    return this.http.post<ActionResultList<CompetitorResults[], number>>(this.environmentService.getApiUrl() + "/api/public/races/getcompetitorresultsforrace2", filter).pipe(map((value: ActionResultList<CompetitorResults[], number>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }

  findCategoryItemsByRaceId(raceId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(this.environmentService.getApiUrl() + `/api/public/category/race/${raceId}`).pipe(map((value: ActionResult<CategoryItem[]>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }

  findCategoryItemsByEventId(eventId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(this.environmentService.getApiUrl() + `/api/public/category/event/${eventId}`).pipe(map((value: ActionResult<CategoryItem[]>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }
}


